<template>
  <footer id="footer" class="bg-[#FFE9A0] text-black py-10 px-8 shadow-md">
    <div class="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-12">

      <!-- Logo & About -->
      <div>
        <h2 class="text-3xl font-extrabold text-[#D84040]">সংস্কৃতিৰ দাপোণ</h2>
        <p class="mt-4 text-lg text-gray-700">
          Stay updated with the latest news, trends, and insights from around the world.
        </p>
      </div>

      <!-- Quick Links -->
      <div>
        <h3 class="text-2xl font-semibold text-[#D84040]">Quick Links</h3>
        <ul class="mt-4 space-y-3 text-lg">
          <li>
            <router-link to="/" class="hover:text-[#D84040] transition">
              Home
            </router-link>
          </li>
          <li>
            <router-link to="/gallery" class="hover:text-[#D84040] transition">
              Gallery
            </router-link>
          </li>
          <li>
            <router-link to="/about" class="hover:text-[#D84040] transition">
              About Us
            </router-link>
          </li>
          <li>
            <router-link to="/suggestion" class="hover:text-[#D84040] transition">
              Suggestion
            </router-link>
          </li>
          <li>
            <router-link to="/contact" class="hover:text-[#D84040] transition">
              Contact Us
            </router-link>
          </li>
        </ul>
      </div>

      <!-- Subscribe -->
      <div>
        <h3 class="text-2xl font-semibold text-[#D84040]">Subscribe</h3>
        <p class="mt-4 text-lg text-gray-700">
          Join our newsletter for daily news updates.
        </p>
        <div class="mt-4 flex justify-center">
          <a href="/subscribe">
  <button
    class="bg-[#D84040] text-white px-6 py-3 rounded-md hover:bg-[#C32F32] transition duration-200"
  >
    Subscribe
  </button>
</a>

        </div>
      </div>
    </div>

    <div class="text-center mt-8 text-gray-600 text-sm">
      &copy; 2025 সংস্কৃতিৰ দাপোণ. All Rights Reserved.
    </div>
  </footer>
</template>
